import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlowerLotus = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3904 30.5607C13.2473 30.5848 12.1195 30.2943 11.1302 29.7209C10.1409 29.1476 9.3282 28.3134 8.78083 27.3095C6.77741 23.8636 9.26165 14.6479 9.26165 14.6479C9.26165 14.6479 10.4172 14.9508 11.9863 15.4749",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.0137 15.4749C29.5828 14.9508 30.7384 14.6479 30.7384 14.6479C30.7384 14.6479 33.2226 23.8636 31.2192 27.3095C30.6718 28.3134 29.8591 29.1476 28.8698 29.7209C27.8806 30.2943 26.7528 30.5848 25.6096 30.5607",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7877 21.9404C12.7877 17.4527 20 10 20 10C20 10 27.2123 17.4527 27.2123 21.9404C27.2329 22.8969 27.061 23.8478 26.7068 24.7366C26.3527 25.6254 25.8235 26.434 25.1507 27.1142C24.4779 27.7945 23.6753 28.3326 22.7905 28.6965C21.9057 29.0605 20.9567 29.2429 20 29.2329C19.0433 29.2429 18.0944 29.0605 17.2095 28.6965C16.3247 28.3326 15.5221 27.7945 14.8493 27.1142C14.1765 26.434 13.6473 25.6254 13.2932 24.7366C12.939 23.8478 12.7671 22.8969 12.7877 21.9404V21.9404Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgFlowerLotus);
export default ForwardRef;
